import React from 'react';
import { Tooltip } from '@material-ui/core';
import { FiberManualRecord, Info } from '@material-ui/icons';
import { convertDateToPST } from '../../../../helpers/audit-trail';

export const isUnread = (id, unread) => {
  const unreadIdx = unread.findIndex(el => el.id === id);
  return unreadIdx >= 0;
};

export const getColumns = unread => [
  {
    field: 'group_name',
    headerName: 'Group',
    width: 150,
    headerClassName: 'audit-trail-groups',
    renderCell: params =>
      isUnread(params.row.id, unread) ? (
        <>
          <FiberManualRecord className="audit-trail-groups-new-value-dot" />
          <span>{params.row.group_name ? params.row.group_name : ''}</span>
        </>
      ) : (
        <span>{params.row.group_name ? params.row.group_name : ''}</span>
      ),
    sortable: false,
  },
  {
    field: 'object_type',
    headerClassName: 'audit-trail-groups',
    headerName: 'Field',
    width: 200,
    sortable: false,
    renderCell: params =>
      params.row.object_type && (
        <Tooltip arrow title={<h3>{params.row.object_type}</h3>}>
          <span className="table-cell-trucate">{params.row.object_type}</span>
        </Tooltip>
      ),
  },
  {
    field: 'event',
    headerClassName: 'audit-trail-groups',
    headerName: 'Action',
    width: 100,
    sortable: false,
  },
  {
    field: 'old_value',
    headerClassName: 'audit-trail-groups',
    headerName: 'Old Value',
    width: 200,
    sortable: false,
    renderHeader: () => {
      return (
        <>
          <span>Old Value</span>
          <Tooltip
            arrow
            title={
              <h3>Shows the previous value, if text do not fit, please hover over the text, to see all the details</h3>
            }
          >
            <Info className="audit-trail-header-icons" />
          </Tooltip>
        </>
      );
    },
    renderCell: params =>
      params.row.old_value && (
        <Tooltip arrow title={<h3>{params.row.old_value}</h3>}>
          <span className="table-cell-trucate">{params.row.old_value.replace(/['"]+/g, '')}</span>
        </Tooltip>
      ),
  },
  {
    field: 'new_value',
    headerClassName: 'audit-trail-groups',
    cellClassName: 'audit-trail-groups-new-value',
    headerName: 'New Value',
    width: 200,
    sortable: false,
    renderHeader: () => {
      return (
        <>
          <span>New Value</span>
          <Tooltip
            arrow
            title={
              <h3>Shows the new value added, if text do not fit, please hover over the text, to see all the details</h3>
            }
          >
            <Info className="audit-trail-header-icons" />
          </Tooltip>
        </>
      );
    },
    renderCell: params =>
      params.row.new_value && (
        <Tooltip arrow title={<h3>{params.row.new_value}</h3>}>
          <span className="table-cell-trucate">{params.row.new_value.replace(/['"]+/g, '')}</span>
        </Tooltip>
      ),
  },
  {
    field: 'created_on',
    headerClassName: 'audit-trail-groups',
    headerName: 'Datetime',
    width: 150,
    renderHeader: () => {
      return (
        <>
          <span>Datetime</span>
          <Tooltip arrow title={<h3>Shows the datetime on when the change happenned (PST)</h3>}>
            <Info className="audit-trail-header-icons" />
          </Tooltip>
        </>
      );
    },
    renderCell: params =>
      params.row.created_on && (
        <Tooltip title={convertDateToPST(params.row.created_on)}>
          <span className="table-cell-trucate">{convertDateToPST(params.row.created_on)}</span>
        </Tooltip>
      ),
  },
  {
    field: 'actor_id',
    headerClassName: 'audit-trail-groups',
    headerName: 'Userid/SystemID',
    width: 200,
    sortable: false,
    renderHeader: () => {
      return (
        <>
          <span>Userid/SystemID</span>
          <Tooltip arrow title={<h3>Shows who performed the changes, it could be a user email or an API</h3>}>
            <Info className="audit-trail-header-icons" />
          </Tooltip>
        </>
      );
    },
    renderCell: params =>
      params.row.actor_id && (
        <Tooltip title={params.row.actor_id}>
          <span className="table-cell-trucate">{params.row.actor_id}</span>
        </Tooltip>
      ),
  },
];
